export enum StoredTokens {
  currentUser = 'currentUser',
  storedTwoFactor = 'storedTwoFactor',
  currentChannel = 'currentChannel',
}
